import React from "react";
import Input from "../Input";
import Select from "../Select";
import { toFiniteNumber } from "../../utils/number";

const QuestionCard = ({ id, title, question, type, dropdown, inputValue, setInputValue, dropValue, setDropValue, minValue, maxValue }) => {
  const min = toFiniteNumber(minValue);
  const max = toFiniteNumber(maxValue);
  const hasBounds = min !== null || max !== null;
  const isDropdown = type === "dropdown";

  const handleInputChange = e => {
    const raw = e?.target?.value ?? "";

    if (raw === "") {
      setInputValue("");
      return;
    }

    setInputValue(hasBounds ? Number(raw) : String(raw));
  };

  return (
    <div className="question-card">
      <div className="title mb-4">{title}</div>
      <div className="question mb-16">{question}</div>
      {isDropdown ? (
        <Select options={dropdown} value={dropValue} onChange={e => setDropValue(e.target.value)} />
      ) : (
        <>
          <Input type={hasBounds ? "number" : "text"} onChange={handleInputChange} value={inputValue} min={min ?? ""} max={max ?? ""} />
          {min !== null && max !== null && (
            <p>
              Value must be between {min} and {max}
            </p>
          )}
        </>
      )}
    </div>
  );
};

export default QuestionCard;
